export const HR_INSURANCE_PAYMENT_PERMISSION_CODES = {
    WEB_HR_INSURANCE_PAYMENT_LIST: 'WEB_HR_INSURANCE_PAYMENT_LIST',
    WEB_HR_INSURANCE_PAYMENT_DETAIL: 'WEB_HR_INSURANCE_PAYMENT_DETAIL',
    WEB_HR_INSURANCE_PAYMENT_ADD: 'WEB_HR_INSURANCE_PAYMENT_ADD',
    WEB_HR_INSURANCE_PAYMENT_EDIT: 'WEB_HR_INSURANCE_PAYMENT_EDIT',
    WEB_HR_INSURANCE_PAYMENT_DELETE: 'WEB_HR_INSURANCE_PAYMENT_DELETE',
    WEB_HR_INSURANCE_PAYMENT_IMPORT: 'WEB_HR_INSURANCE_PAYMENT_IMPORT',
    WEB_HR_INSURANCE_PAYMENT_EXPORT: 'WEB_HR_INSURANCE_PAYMENT_EXPORT',
} as const;

